/**
 * Copyright (c) 2024 Khaled Sameer <khaled.smq@hotmail.com>.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 **/

/**
 * Default equality function for comparing signal values
 * Uses Object.is for strict equality comparison
 */
export const defaultEquals = <T>(a: T, b: T): boolean => Object.is(a, b);
